<div class="dialog">
  <h2 mat-dialog-title>{{ local_data.message }}</h2>
  <br>
    <br>
      <div class="dialog-box-s">
        @if (!local_data.isCompleteOrIncomplete) {
          <mat-dialog-actions class="button-group">
            <app-button typeBtn="secondary" message="{{variables.no}}" mat-dialog-close></app-button>
            <app-button typeBtn="primary" message="{{variables.yes}}" (click)="doAction()"></app-button>
          </mat-dialog-actions>
        }

        @if (local_data.isCompleteOrIncomplete) {
          <mat-dialog-actions class="button-group">
            <app-button typeBtn="secondary" message="{{variables.goBack}}" mat-dialog-close></app-button>
            <app-button typeBtn="secondary" message="{{variables.incomplete}}" (click)="doActionIsComplete(false)"
            [matTooltip]="isUsed ? variables.cannotSetCatalogAsOnGoing: ''" [disabled]="this.isUsed"></app-button>
            <app-button typeBtn="primary" message="{{variables.complete}}" (click)="doActionIsComplete(true)"></app-button>
          </mat-dialog-actions>
        }
      </div>
    </div>
